import { CashBreakSuggestion } from './../../models/copilot.model'
import {
  ActionResponse,
  CashBreakSuggestionsModalComponent,
} from '../../components/cash-break-suggestions-modal/cash-break-suggestions-modal.component'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap'
import { Injectable } from '@angular/core'
import {
  RootState,
  setFocusedCWTransactions,
  setFocusedExtTransactions,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { HttpCopilotService } from '../copilot/http-copilot.service'
import { TelemetryService } from '@helios/telemetry'

@Injectable({
  providedIn: 'root',
})
export class CashBreakSuggestionsService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly store: Store<RootState>,
    private readonly httpCopilotService: HttpCopilotService,
    private readonly telemetry: TelemetryService,
  ) {}

  openCashBreaksSuggestionsModal(
    cashBreakSuggestions: CashBreakSuggestion[],
    acctId?: string,
    breakId?: string,
  ) {
    const modalRef = this.modalService.open(
      CashBreakSuggestionsModalComponent,
      {
        size: 'lg',
        modalDialogClass: 'my-1',
        keyboard: false,
      } as NgbModalOptions,
    )
    modalRef.componentInstance.cashBreakSuggestions = cashBreakSuggestions
    modalRef.componentInstance.acctId = acctId
    modalRef.componentInstance.breakId = breakId
    modalRef.result.then(
      (modalAction: ActionResponse<unknown>) => {
        console.log('action made', modalAction)
      },
      (cancelMessage: string) => {
        console.log('cancel or close', cancelMessage)
      },
    )
  }

  filterTransactionsBySuggestion(suggestion: CashBreakSuggestion) {
    const cwTranIds = suggestion.cwTranToClear
      .map(x => x.tranId)
      .concat(suggestion.cwTranToUnclear.map(x => x.tranId))
    const extTranIds = suggestion.extTranToClear.map(x => x.extTranId)
    this.filterTransactions(cwTranIds, extTranIds)
  }

  submitSuggestions(
    request: CashBreakSuggestion,
    acctId?: string,
    breakId?: string,
  ) {
    this.telemetry.emitCustomEvent('submitSuggestions', {
      accountId: acctId,
      breakId: breakId,
    })
    return this.httpCopilotService.submitCashBreakSuggestion(request)
  }

  filterTransactions(cwTranIds: string[], extTranIds: number[]) {
    if (extTranIds.length > 0)
      this.store.dispatch(setFocusedExtTransactions(extTranIds))
    if (cwTranIds.length > 0)
      this.store.dispatch(setFocusedCWTransactions(cwTranIds))
  }
}
